// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"de9a5ee7","154":"05b1b64a","421":"8c234153"}[chunkId] + ".chunk.js";
};